import { observer } from 'mobx-react';
import { useStore } from '../../core/utils/hook';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import './components/styles.scss';
import { flowResult } from 'mobx';
import ReactPaging from '../../components/Table/ReactPaging';
import moment from 'moment';
import { DATE_YMD } from '../../core/configs/constants';

const FirstTestOfCourseScreen = observer(() => {
    const { id } = useParams();

    // store
    const {
        userCourseStore: { getStudentsByCourseId },
        groupAdminStore: { selectedGroupIds, selectedDepartmentIds, gaFilterMode },
        userStore: { userInfoHeader }
    } = useStore();

    const [students, setStudents] = useState({
        elements: [],
        pagination: { currentPage: 1, totalPage: 0, size: 10, totalRecord: 0 }
    });
    const [courseInfo, setCourseInfo] = useState({});

    const isDepartmentFilter = useMemo(() => {
        if (userInfoHeader?.departmentId) {
            return true;
        }
        return !!userInfoHeader?.enableDepartmentHierarchy && gaFilterMode === 'department';
    }, [userInfoHeader?.departmentId, userInfoHeader?.enableDepartmentHierarchy, gaFilterMode]);

    const buildPayload = (extraPayload = {}) => {
        if (isDepartmentFilter) {
            return {
                ...extraPayload,
                departmentIds: selectedDepartmentIds.join(',')
            };
        }
        return {
            ...extraPayload,
            groupId: selectedGroupIds.join(',')
        };
    };

    // state
    const fetchData = async (payload) => {
        const res = await flowResult(getStudentsByCourseId(id, payload));
        if (res) {
            setStudents({
                elements: res.elements,
                pagination: res.pagination,
            });
            setCourseInfo(res.courseInfo || {});
        } else {
            setStudents({
                elements: [],
                pagination: { currentPage: 1, totalPage: 0, size: 10, totalRecord: 0 }
            });
            setCourseInfo({});
        }
    };

    useEffect(() => {
        if (!isDepartmentFilter && selectedGroupIds.length === 0) return;
        if (isDepartmentFilter && selectedDepartmentIds.length === 0) return;
        const payload = buildPayload();
        fetchData(payload);
    }, [isDepartmentFilter, selectedGroupIds, selectedDepartmentIds]);

    return (
        <div className="container first-test-of-course-screen">
            <p className="title">受講者一覧</p>
            <div className="course-info">
                <p className="course-name truncate">
                    <span>講座名</span>
                    <span data-bs-toggle="tooltip" data-bs-placement="bottom" title={courseInfo.courseName}>
                        {courseInfo.courseName}
                    </span>
                </p>
                <p className="course-average">
                    <span>テスト正答率平均値</span>{' '}
                    <span>
                        {courseInfo?.averageScore != null && !Number.isNaN(Number(courseInfo.averageScore))
                            ? `${+Number(courseInfo.averageScore).toFixed(2)}%`
                            : '---'}
                    </span>
                </p>
            </div>
            <div>
                {students?.elements?.length > 0 ? students.elements.map((item, index) => (
                    <div key={index} className={`test-result-item ${index % 2 === 0 ? 'bg-gray-1' : 'bg-white'}`}>
                        <div className="no">
                            <span>
                                {students.pagination.currentPage === 1
                                    ? index + 1
                                    : (students.pagination.currentPage - 1) * students.pagination.size + index + 1}
                            </span>
                        </div>
                        <div className="name">
                            <p className="label">受講者名</p>
                            <p
                                className="value truncate"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title={item.firstName + ' ' + item.lastName}
                            >
                                {item.firstName} {item.lastName}
                            </p>
                        </div>
                        <div className="email">
                            <p className="label">メールアドレス</p>
                            <p className="value truncate">{item.email}</p>
                        </div>
                        <div className="organization">
                            <p className="label">法人名</p>
                            <p
                                className="value truncate "
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title={item.companyName}
                            >
                                {item.companyName}
                            </p>
                        </div>
                        <div className="course-start">
                            <p className="label">講座受講開始日</p>
                            <p className="value">
                                {item.startDate ? moment(item.startDate).format(DATE_YMD) : '---'}
                            </p>
                        </div>
                        <div className="course-end">
                            <p className="label">受講終了日</p>
                            <p className="value">{item.endDate ? moment(item.endDate).format(DATE_YMD) : '---'}</p>
                        </div>
                        <div className="initial-correct-answer-rate">
                            <p className="label">初回正答率</p>
                            <p className="value percentage">{item.score}%</p>
                        </div>
                    </div>
                )) : (
                    <div className="no-data text-center pd-tb-20">データはありません</div>
                )}
            </div>
            <div className="table-footer">
                <ReactPaging
                    forcePage={students?.pagination?.currentPage - 1 || 0}
                    pageCount={students?.pagination?.totalPage || 0}
                    onPageChange={({ selected }) => {
                        const payload = buildPayload({ page: selected + 1 });
                        fetchData(payload);
                    }}
                />
            </div>
        </div>
    );
});

export default FirstTestOfCourseScreen;
